<template lang="pug">
.PopupWorkspace
  .PopupWorkspace-header
    h2 Управление рабочими пространствами

  .PopupWorkspace-body
    vue-scrollbar.List(ref='workspaceList')
      div
        .List-item(
          v-for='workspace in workspaceList',
          :class='{ "List-item--selected": workspace.id === $store.getters.workspace }',
          :data-id='workspace.id'
        )
          .List-item-name(
            v-if='workspaceNotEditing(workspace)',
            :title='workspace.fullName'
          ) {{ workspace.fullName }}
          .List-item-id(v-if='isEditing[workspace.id] || isEditing[workspace.id] === ""') [{{ workspace.id }}]
          input.TextInput.TextInput--block(
            v-if='isEditing[workspace.id] || isEditing[workspace.id] === ""',
            :ref='`workspaceNameInputs_${workspace.id}`',
            type='text',
            :disabled='isSaving[workspace.id]',
            v-model='isEditing[workspace.id]',
            @keydown.enter='saveWorkspaceName(workspace.id)',
            @keydown.stop.esc='cancelNameEditing(workspace.id)'
          )
          .List-item-info(v-if='workspace.infoText')
            | {{ workspace.infoText }}
          .List-actions
            //- Кнопка "Редактировать название рабочего пространства"
            button.Btn.BtnIcon(
              v-if='workspace.can_edit && workspaceNotEditing(workspace)',
              :id='"ActivateWorkspacePopup_editName_" + workspace.id',
              @click='editWorkspaceName(workspace.id, workspace.name)',
              @mouseover='helperText = "Редактировать название рабочего пространства"',
              @mouseout='helperText = null'
            )
              i.Icon.IconPanelEditObject

            //- Кнопка "Копировать рабочее пространство"
            button.Btn.BtnIcon(
              v-if='$store.getters.permissions.canCreateWs && workspaceNotEditing(workspace)',
              @click='copyWorkspaceClick(workspace.id, workspace.name)',
              @mouseover='helperText = "Копировать рабочее пространство"',
              @mouseout='helperText = null'
            )
              i.Icon.IconCopy

            //- Кнопка "Сохранить изменения"
            button.Btn.BtnIcon(
              v-if='workspace.can_edit && workspaceIsEditing(workspace)',
              :id='"ActivateWorkspacePopup_saveName_" + workspace.id',
              @click='saveWorkspaceName(workspace.id)',
              @mouseover='helperText = "Сохранить изменения"',
              @mouseout='helperText = null'
            )
              i.Icon.IconModelingSuccess

            //- Кнопка "Отменить изменения"
            button.Btn.BtnIcon(
              v-if='isEditing[workspace.id] || isEditing[workspace.id] === ""',
              :id='"ActivateWorkspacePopup_saveName_" + workspace.id',
              @click='cancelNameEditing(workspace.id)',
              @mouseover='helperText = "Отменить изменения"',
              @mouseout='helperText = null'
            )
              i.Icon.IconClose

            //- Кнопка "Удалить рабочее пространство"
            button.Btn.BtnIcon(
              v-if='workspace.can_edit && $store.getters.permissions.canDeleteWs',
              :id='"ActivateWorkspacePopup_delete_" + workspace.id',
              @click='deleteWorkspace(workspace.id)',
              @mouseover='helperText = "Удалить рабочее пространство"',
              @mouseout='helperText = null'
            )
              i.Icon.IconRemove

  .PopupWorkspace-footer
    button#ActivateWorkspacePopup_submit.Btn.Btn--blue(@click='ok') Готово
</template>

<script>
import VueScrollbar from '@/components/scrollbar/vue-scrollbar'
import limits from '@/mixins/limits'
import copyWorkspace from '@/mixins/copyWorkspace'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'activate-workspace',

  mixins: [limits, copyWorkspace, helpertext],

  components: {
    VueScrollbar
  },

  data() {
    return {
      isEditing: {},
      isSaving: {}
    }
  },

  computed: {
    workspaceList() {
      return this.$store.getters.activeWorkspaceList.map((workspaceItem) => {
        const infoArray = []
        if (workspaceItem.public) {
          infoArray.push('Публичное')
        }
        if (workspaceItem.shared) {
          infoArray.push('Общее')
        }

        return {
          ...workspaceItem,
          fullName: workspaceItem.fullName + (workspaceItem.status === 'broken' ? ' [Устаревшее]' : ''),
          infoText: infoArray.join('; ') || null
        }
      })
    }
  },

  watch: {
    workspaceList() {
      this.reinitScroll()
    }
  },

  mounted() {
    this.getList().then(() => {
      this.$nextTick(() => {
        if (!this.$refs.workspaceList) {
          return
        }

        const listElement = this.$refs.workspaceList.$el
        const activeElement = listElement.querySelector('.List-item--selected')
        if (activeElement) {
          this.$refs.workspaceList.scrollToY(activeElement.offsetTop - listElement.offsetHeight / 2)
        }
      })
    })
  },

  methods: {
    reinitScroll() {
      if (this.$refs.workspaceList) {
        this.$refs.workspaceList.onResizeWindow()
      }
    },

    editWorkspaceName(ws, name, index) {
      this.isEditing = {
        ...this.isEditing,
        [ws]: name
      }
      this.$nextTick(() => {
        const nameInput = this.$refs[`workspaceNameInputs_${ws}`]
        if (nameInput && nameInput[0]) {
          nameInput[0].focus()
        }
      })
    },

    cancelNameEditing(ws) {
      this.isEditing = {
        ...this.isEditing,
        [ws]: null
      }
    },

    saveWorkspaceName(ws) {
      if (this.isEditing[ws] && !this.isSaving[ws]) {
        this.setIsSaving(ws, true)
        this.$store
          .dispatch('editWorkspace', {
            id: ws,
            fields: {
              name: this.isEditing[ws]
            }
          })
          .then((r) => {
            this.setIsSaving(ws, false)
            this.cancelNameEditing(ws)
            this.$ui.toast.show({ text: 'Название рабочего пространства ' + ws + ' обновлено', type: 'success' })
          })
          .catch((e) => {
            this.setIsSaving(ws, false)
          })
      }
    },

    setIsSaving(ws, value) {
      this.isSaving = {
        ...this.isSaving,
        [ws]: value
      }
    },

    ok() {
      this.$ui.popup.ok()
    },

    getList() {
      return this.$store.dispatch('getWorkspaces')
    },

    deleteWorkspace(id) {
      this.$ui.popup.ok({ action: 'deleteWorkspace', workspace: id })
    },

    selectWorkspace() {
      if (this.selectedWorkspace) {
        this.$store.dispatch('activateWorkspace', this.selectedWorkspace.id)
      }
    },

    copyWorkspaceClick(workspaceId, workspaceName) {
      this.$store
        .dispatch('loadWorkspaceDataversion', {
          workspace: workspaceId
        })
        .then((result) => {
          const activeVersion = result.body.results.find((versionItem) => versionItem.is_active)
          if (!activeVersion) {
            this.$ui.toast.show({ text: 'Не удалось определить активную версию рабочего пространства.', type: 'error', time: 5000 })
          }
          this.openCopyWorkspacePopup(workspaceId, activeVersion.version, workspaceName)
        })
    },

    workspaceNotEditing(workspace) {
      return !this.isEditing[workspace.id] && this.isEditing[workspace.id] !== ''
    },

    workspaceIsEditing(workspace) {
      return this.isEditing[workspace.id] && this.isEditing[workspace.id] !== ''
    }
  }
}
</script>

<style lang="scss">
@import '~base';

.Popup .PopupWorkspace {
  --footerBorder: #{$grey3};
  --valueColor: #{$grey8};
  --textError: #{$red};
  --selectedBg: #{$grey7};
}

.Popup[data-theme='dark'] .PopupWorkspace {
  --footerBorder: #{$grey2};
  --textError: #{$red};
  --selectedBg: #{$grey11};
}
</style>
<style scoped lang="scss">
@import '~base';

.PopupWorkspace {
  position: relative;

  &-error {
    padding: 10px 20px;
    color: red;
    font-size: 14px;
    text-align: center;
  }

  &-header {
    padding: 25px 30px 15px;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-body {
    padding: 10px 0px 30px 0px;
  }

  &-footer {
    padding: 5px 30px 10px;
    border-top: 1px solid var(--footerBorder);

    .Btn {
      min-width: 155px;
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;
    }

    .Btn + .Btn {
      margin-left: 12px;
    }
  }
}

.List {
  max-height: 300px;
  min-height: 300px;

  &-item {
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 30px;
    line-height: 32px;

    &-name,
    &-id {
      flex: 1 1 auto;
      font-size: 12px;
      white-space: nowrap;
    }

    &-name {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .TextInput {
      margin-left: 10px;
    }

    button {
      margin-left: 5px;
      font-size: 12px;
      flex: 0 0 auto;
      min-width: 30px;

      .Icon {
        font-size: 16px;
        color: var(--basicText);

        &.IconModelingSuccess {
          font-size: 28px;
        }

        &.IconClose {
          font-size: 14px;
        }
      }

      .IconRemove {
        color: var(--textError);
      }
    }

    button:hover {
      .Icon {
        color: var(--accentColor);
      }

      .IconRemove {
        color: var(--textError);
      }
    }

    &--selected {
      background: var(--selectedBg);
      color: var(--basicText);
      font-weight: bold;
    }
  }

  &-actions {
    display: flex;
    align-items: center;
  }

  &-item-info {
    margin-left: 10px;
    font-size: 12px;
    line-height: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ActivateWorkspace.vue